import { useFeatureFlag } from 'hooks/useFeatureFlag';
import { QueueState } from 'lib_ts/enums/machine-msg.enum';
import {
  CONTINUOUS_TRAINING_SUPPORTED_DEVICES,
  FF_NAME_CONTINUOUS_TRAINING,
  TrackingDevice,
} from 'lib_ts/enums/training.enums';
import { IMachineModel } from 'lib_ts/interfaces/modelling/i-machine-model';
import { useEffect } from 'react';
import { useTrainedMsStore } from 'stores/use-trained-ms-store';

const useSyncReadyToContTrain = (props: {
  loading: boolean; // i.e. machine cx loading
  activeModel: IMachineModel | undefined;
  queueState: QueueState;
  trackingDevice: TrackingDevice;
}) => {
  const enabled = useFeatureFlag(FF_NAME_CONTINUOUS_TRAINING);

  const loadingTms = useTrainedMsStore((s) => s.loading);

  useEffect(() => {
    useTrainedMsStore.setState({
      readyToContTrain: (() => {
        if (props.loading) {
          // wait until machine context is loaded to know about the tracking device, active model, etc...
          return false;
        }

        if (!enabled) {
          // continuous training is not enabled by the user
          return false;
        }

        if (
          !CONTINUOUS_TRAINING_SUPPORTED_DEVICES.includes(props.trackingDevice)
        ) {
          // machine's tracking device is not CT-supported
          return false;
        }

        if (!props.activeModel) {
          // model is not loaded yet
          return false;
        }

        if (props.activeModel?.calibration_only) {
          // model can only be used for calibration
          return false;
        }

        if (props.queueState !== QueueState.Active) {
          // only the active user can train
          return false;
        }

        if (loadingTms) {
          // wait until TMS has loaded to know what needs training
          return false;
        }

        return true;
      })(),
    });
  }, [
    props.loading,
    props.activeModel,
    props.queueState,
    props.trackingDevice,
    enabled,
    loadingTms,
  ]);
};

export default useSyncReadyToContTrain;
